export default "__VITE_ASSET__CWIeiEtA__"